<template>
  <div class="wlx-site-manager-wrapper">
    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="全部培训活动" name="first">
      <allTraining v-if="activeName=='first'"></allTraining>
    </el-tab-pane>
    <el-tab-pane label="我的报名活动" name="second">
      <mySignUpTraining v-if="activeName=='second'"></mySignUpTraining>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>
import allTraining from "page/xSchool/teaManager/allTraining.vue";
import mySignUpTraining from "page/xSchool/teaManager/mySignUpTraining.vue";
export default {
  data(){
    return {
      activeName:'first'
    }
  },
  components:{
    allTraining,
    mySignUpTraining
  },
  methods:{
    handleClick(tab, event){
      console.log(tab, event);
    },
  }
};
</script>

<style>
</style>
